
import XInput from 'vux/src/components/x-input/index.vue'

export default {
name: 'CompanySearch',
components: { XInput },
props: {
value: String,
title: String,
placeholder: String,
required: Boolean,
min: Number,
max: Number,
tianyanchaToken: String
},
data() {
return {
inputValue: '',
companyList: [],
showList: false,
timer: null,
isSelecting: false,
initialized: false,
selectedCompany: null
}
},
watch: {
value: {
handler(val) {
this.inputValue = val
},
immediate: true
}
},
mounted() {
setTimeout(() => {
this.initialized = true
}, 1000)
},
methods: {
handleInput(val) {
clearTimeout(this.timer)
this.$emit('input', val)

if (!this.initialized || this.isSelecting) {
this.isSelecting = false
this.companyList = []
return
}

this.selectedCompany = null
if (!val || val.length < 2) {
this.companyList = []
return
}

this.timer = setTimeout(() => {
this.search(val)
}, 400)
},
async search(word) {
try {
const res = await this.$axios.post('/openapi/tianyancha/search', null, { params: { word, pageSize: 10 } })
if (res.meta.success) {
this.companyList = res.data.result.items || []
}
} catch (e) {
this.companyList = []
}
},
selectItem(item) {
this.isSelecting = true
this.inputValue = item.name
this.selectedCompany = item
this.$emit('input', item.name)
this.$emit('select-company', item)
this.companyList = []
},

handleBlur() {
console.log('handleBlur begin，selectedCompany：' + this.selectedCompany)
setTimeout(() => {
this.companyList = []


if (!this.selectedCompany) {
this.inputValue = ''
this.$emit('input', '')
}
}, 280)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/lottery/components/CompanySearch.vue